// extracted by mini-css-extract-plugin
export var container = "styles-module--container--QjqDA";
export var navbar = "styles-module--navbar--3Xu9p";
export var content = "styles-module--content--BM9Tr";
export var footer = "styles-module--footer--N0TI5";